import styled from 'styled-components';

const SectionSubHeader = styled.div`
    color: #C2C2C2;
    font-family: GothamBook;
    font-size: 12px;
    font-style: italic;
`;

export const ReportSectionSubHeader = styled(SectionSubHeader)`
    padding-top: 0px;
    padding-bottom: 5px;
`;

export const CommissionSubHeaders = styled(SectionSubHeader)`
`;



// WEBPACK FOOTER //
// ./src/common/components/SectionSubHeader.js